import { render, staticRenderFns } from "./card-group.vue?vue&type=template&id=1c483fbe&scoped=true"
import script from "./card-group.ts?vue&type=script&lang=ts&external"
export * from "./card-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c483fbe",
  null
  
)

export default component.exports